import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavBar from '../components/NavBar';
import { sessionEnd } from '../actions/session';
import { fetchUser } from '../actions/user';
import UserProps from '../proptypes/user';
import { BASE_DOMAIN, IDP_URL } from '../constants';
import { NAV_LOGO, selectNavLogo } from '../fragno1/navLogo';

export class NavBarContainer extends Component {
  static propTypes = {
    actionFetchUser: PropTypes.func.isRequired,
    actionSignout: PropTypes.func.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    isLoggingOut: PropTypes.bool.isRequired,
    navLogo: PropTypes.oneOf(Object.values(NAV_LOGO)),
    user: UserProps,
  };

  static defaultProps = {
    navLogo: null,
    user: {
      email: '',
      fname: '',
      lname: '',
    },
  };

  componentDidMount() {
    // Boot may have finished the session check before mount.
    const { actionFetchUser, isLoggedIn, user } = this.props;
    if (isLoggedIn && !user.email && !user.isFetching) {
      actionFetchUser();
    }
  }

  componentDidUpdate(prevProps) {
    const { actionFetchUser, isLoggedIn } = this.props;
    if (isLoggedIn && !prevProps.isLoggedIn) {
      actionFetchUser();
    }
  }

  render() {
    const { isLoggedIn, navLogo, user } = this.props;

    // To prevent the NavBar from flashing before redirecting to IDP:
    // do not show the NavBar if
    // the user is not logged in
    // AND is not redirecting from an ID.me site
    //   OR is redirecting from IDP
    if (
      !isLoggedIn &&
      (!document.referrer.includes(BASE_DOMAIN) ||
        document.referrer.includes(IDP_URL))
    ) {
      return null;
    }

    return <NavBar isLoggedIn={isLoggedIn} navLogo={navLogo} user={user} />;
  }
}

export const mapStateToProps = (state) => {
  return {
    ...state.session,
    navLogo: selectNavLogo(state),
    user: state.user,
  };
};

const mapDispatchToProps = {
  actionFetchUser: fetchUser,
  actionSignout: sessionEnd,
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBarContainer);
